<div>
  <div class="table-container">
    <div *ngIf="loading" class="loader-overlay">
      <div class="spinner-container">
        <mat-spinner color="primary" diameter="30"></mat-spinner>
      </div>
    </div>
    <table mat-table [dataSource]="colleagues" [trackBy]="trackByUserId">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          Naam
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.firstName | joiner: ' ':row.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          Telefoonnummer
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.phoneNumber | asFormatPhoneNumber | or }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mobileNumber">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          Gsm
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.mobileNumber | asFormatPhoneNumber | or }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          Email
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{ row.email | or }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastLogin">
        <th mat-header-cell *matHeaderCellDef class="header-text">
          Laatste login
        </th>
        <td mat-cell *matCellDef="let row" class="table-text">
          {{
            row.lastLogin | date: 'dd/MM/yyyy HH:mmu':'Europe/Brussels':'nl-BE'
          }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        mat-row
        class="table-row"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>
  <div
    *ngIf="colleagues == null || colleagues.length === 0"
    class="no-result-text"
  >
    <div>Geen logingegevens gevonden</div>
  </div>
</div>
